<template>
  <div class="wrap-chairman-biography">
    <Title
      main="MESSAGE FROM"
      des="CHAIRMAN"
    />
    <Skeleton
      v-if="isLoading"
      width="100%"
      height="720px"
    />
    <div v-if="!isLoading">
      <ContentImage
        v-for="(imgUrl, i) in imgUrls"
        :key="i"
        :imageSUrl="imgUrl"
        :imageMUrl="imgUrl"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
const Skeleton = () => import('@/components/Loading/Skeleton')
const Title = () => import('./Parts/Title')
const ContentImage = () => import('./Parts/ContentImage')

export default {
  components: {
    Skeleton,
    Title,
    ContentImage
  },

  data () {
    return {
      imgUrls: []
    }
  },

  computed: {
    ...mapState({
      isLoading: state => state.about.isLoading,
      messageChairman: state => state.about.chairmanBios
    })
  },

  methods: {
    matchImgUrl (urls) {
      urls.forEach(chairmanBio => {
        const urls = `https://admanawards.com/storage/app/img/about/chairman/${chairmanBio.message_image}`

        this.imgUrls.push(urls)
      })
    }
  },

  created () {
    if (!this.messageChairman) {
      this.$store.dispatch('about/getChairmanBio')
    } else {
      this.matchImgUrl(this.messageChairman)
    }
  },

  watch: {
    messageChairman (data) {
      this.matchImgUrl(data)
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap-chairman-biography {
  padding: 22px 0;
}
</style>
